module.exports = __webpack_public_path__ + "static/img/baoming.8b1f25b9.png";